import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useData } from '../context/DataContext';
import styles from './ArtistDetail.module.css';

export default function ArtistDetail() {
  const { id } = useParams();
  const { artists, gallery } = useData();

  const artist = artists.find(a => String(a.id) === id);
  if (!artist) {
    return (
      <div className={styles.notFound}>
        <h1>Artist bulunamadı</h1>
        <Link to="/" className="btn-primary">Ana Sayfaya Dön</Link>
      </div>
    );
  }

  // Filter gallery by artistId or artist name match
  const works = gallery.filter(
    g => g.artistId === artist.id || g.artist === artist.name
  );

  return (
    <main className={styles.page}>
      {/* Back link */}
      <Link to="/#artists" className={styles.backLink}>← Geri Dön</Link>

      {/* Artist header */}
      <section className={styles.header}>
        <div className={styles.headerImg}>
          {artist.photo
            ? <img src={artist.photo} alt={artist.name} />
            : <div className={styles.headerPlaceholder}>{artist.name[0]}</div>
          }
        </div>
        <div className={styles.headerInfo}>
          <h1 className={styles.name}>{artist.name}</h1>
          <p className={styles.style}>{artist.style}</p>
          <p className={styles.bio}>{artist.bio}</p>
          <div className={styles.tags}>
            {artist.tags.map(t => (
              <span key={t} className={styles.tag}>{t}</span>
            ))}
          </div>
          <div className={styles.meta}>
            {artist.instagram && (
              <a
                href={`https://instagram.com/${artist.instagram.replace('@', '')}`}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.instaLink}
              >
                {artist.instagram}
              </a>
            )}
            <span className={`${styles.availBadge} ${artist.available ? styles.open : styles.closed}`}>
              {artist.available ? 'Randevu Açık' : 'Randevu Dolu'}
            </span>
          </div>
          {artist.available && (
            <a href="/#contact" className="btn-primary" style={{ marginTop: 24 }}>Randevu Al</a>
          )}
        </div>
      </section>

      {/* Works */}
      <section className={styles.works}>
        <div className={styles.worksLabel}>
          <span className={styles.sectionLabel}>Çalışmaları</span>
          <span className={styles.worksCount}>{works.length} eser</span>
        </div>

        {works.length > 0 ? (
          <div className={styles.worksGrid}>
            {works.map(w => (
              <div key={w.id} className={styles.workItem}>
                {w.url
                  ? <img src={w.url} alt={w.title} />
                  : <div className={styles.workPlaceholder}>{w.title}</div>
                }
                <div className={styles.workOverlay}>
                  <div className={styles.workTitle}>{w.title}</div>
                  <div className={styles.workStyle}>{w.style}</div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className={styles.emptyWorks}>
            <p>Bu artiste ait henüz çalışma eklenmemiş.</p>
          </div>
        )}
      </section>
    </main>
  );
}
